import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { loaderStateTrue, loaderStateFalse, handleActiveLink } from '../../../../Actions/AllAction';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { InfiniteRowModelModule } from '@ag-grid-community/infinite-row-model';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { staffList, user_Details, staffStatusUpdate, staffCreate, individualUser, allHotelsList, staffDelete, getHotelBranchList, getRoomTypeList, roleListGet, getStoreList } from './Controller/UserController';
import Utility from '../../../Utility/Utility';
import AutosuggestComponent from '../../../Utility/Components/AutosuggestComponent'
import { DebounceInput } from 'react-debounce-input';
import PopoverStickOnHover from '../../../Utility/Components/PopoverStickOnHover';
import GridActionContent from '../../../Utility/Components/GridActionContent';
import ErrorBoundary from '../../../Utility/Components/ErrorBoundary';
import CustomButton from '../../../Utility/Components/CustomButton';
import ModalGlobal from '../../../Utility/Components/ModalGlobal';
import BootstrapSwitchButton from 'bootstrap-switch-button-react';
import UserAddEditModalContent from './Components/UserAddEditModalContent';
import ValidateUtility from '../../../Utility/ValidateUtility';
import logger from '../../../../logger';
import { withNamespaces } from 'react-i18next';
import '../../Assets/css/userDoc.scss';
import UserProfile from '../../Pages/UserProfile'
import ConfirmationAlert from '../../../Utility/Components/ConfirmationAlert'
import UserHistoryModalContent from './Components/UserHistoryModalContent';
import CustomNoRowsOverlay from '../../../Utility/Components/CustomNoRowsOverlay'
import RefreshButton from '../../../Utility/Components/RefreshButton'
import ReactTooltip from 'react-tooltip';
import parsePhoneNumber from 'libphonenumber-js';
import { setUserEntryType } from '../../../Login/Actions/LoginAction';

function Users(props) {
    let staffRef = useRef(true);
    const [modules, setmodules] = useState([InfiniteRowModelModule]);
    const [defaultColDef, setdefaultColDef] = useState({
        flex: 1,
        minWidth: 50

    });

    const [components, setcomponents] = useState({
        loadingRenderer: (params) => {
            if (params.value !== undefined) {
                return params.value;
            } else {
                return '<img src="https://www.ag-grid.com/example-assets/loading.gif">';
            }
        },
    })

    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);
    const [gridparams, setgridparams] = useState(null);
    const [isAlsoAgentAdmin, setIsAlsoAgentAdmin] = useState(false);


    const [columnDefs, setColumnDefs] = useState(
        [
            {
                headerName: "",
                field: "profile_img_temp",
                maxWidth: 72,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params && params.data) {
                        if (params.data && params.data.profile_img_url) {
                            let parseImageUrl = JSON.parse(params.data.profile_img_url);
                            return <div className="gridusericon">
                                <img src={parseImageUrl.img_url} />
                            </div>
                        } else {
                            return <div className="gridusericon">
                                <img src={require('../../../Utility/Public/images/usericon.png')} />
                            </div>
                        }
                    } else {
                        return null
                    }
                }
            },
            {
                headerName: 'Name',
                field: "name",
                minWidth: 180,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        let concatname = params.data.first_name + "" + params.data.last_name
                        if (params.data.first_name && params.data.first_name && concatname.length > 15) {
                            return <div><span className="textrenderview">
                                <OverlayTrigger overlay={<Tooltip>{params.data && params.data.first_name != "" ? Utility.displayNameFormat(params.data.first_name, params.data.last_name) : ""}</Tooltip>}>
                                    <span >
                                        {params.data && params.data.first_name != "" ? Utility.displayNameFormat(params.data.first_name, params.data.last_name) : ""}
                                    </span>
                                </OverlayTrigger>
                            </span></div>
                        } else {
                            return (<div><span className="textrenderview">{params.data && params.data.first_name != "" ? Utility.displayNameFormat(params.data.first_name, params.data.last_name) : ""}</span></div>)
                        }
                    } else {
                        return null;
                    }
                },
            },

            {
                headerName: 'Designation',
                field: "role_name",
                minWidth: 180,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        if (params.data.hasOwnProperty('UserOrgBranchRoleRelation') && params.data.UserOrgBranchRoleRelation) {
                            if (params.data.UserOrgBranchRoleRelation) {
                                return <div><span className="textrenderview">
                                    <OverlayTrigger overlay={<Tooltip>{params.data.UserOrgBranchRoleRelation[0]?.role_name}</Tooltip>}>
                                        <span >{params.data.UserOrgBranchRoleRelation[0]?.role_name}</span>
                                    </OverlayTrigger>
                                </span></div>
                            } else {
                                return null;
                            }
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Email',
                field: "email",
                minWidth: 250,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        const email = params.data.email ? params.data.email.split('#')[0] : '';
                        if (email && email.length > 20) {
                            return <div><span className="textrenderview">
                                <OverlayTrigger trigger={['hover', 'click']} rootClose={true} overlay={<Tooltip>{email}</Tooltip>}>
                                    <span >{email}</span>
                                </OverlayTrigger>
                            </span></div>
                        } else {
                            return <div><span className="textnowrapview">{email}</span></div>
                        }
                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Phone Number',
                field: "contact_number",
                minWidth: 220,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        const contactNumber = params.data.contact_number ? params.data.contact_number.split('#')[0] : '';
                        if (contactNumber) {
                            return <div><span >{contactNumber}</span></div>
                        } else {
                            return null;
                        }
                    } else {
                        return null;
                    }
                },
            },
            {
                headerName: 'Organizations',
                field: "UserOrgBranchRoleRelation",
                minWidth: 200,
                sortable: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params.data) {
                        if (params.data.hasOwnProperty('UserOrgBranchRoleRelation') && params.data.UserOrgBranchRoleRelation) {
                            const organizations = params.data.UserOrgBranchRoleRelation || [];
                            if (organizations.length > 0) {
                                const firstOrg = organizations[0];
                                const orgName = firstOrg?.OrgUserRelation?.org_name || '';
                                const roleName = firstOrg?.role_name || '';
                                const branchName = firstOrg?.branch_name || '';
                                const moreCount = organizations.length - 1;

                                return (
                                    <div className={moreCount > 0 ? "multiContentBox multiline" : "multiContentBox"}>
                                        <div className="contentBox contentBoxAdmin">
                                            {orgName && orgName.length > 0 && (
                                                <>
                                                    {orgName.length >= 20 ? (
                                                        <OverlayTrigger trigger={['hover', 'click']} rootClose={true} overlay={<Tooltip>{orgName}</Tooltip>}>
                                                            <span>{orgName.substring(0, 17)}...</span>
                                                        </OverlayTrigger>
                                                    ) : (
                                                        <span>{orgName}</span>
                                                    )}
                                                    {/* <div className="orgRoleInfo">
                                                        <small className="text-muted">{roleName}</small>
                                                        {branchName && <small className="text-muted"> • {branchName}</small>}
                                                    </div> */}
                                                </>
                                            )}
                                        </div>
                                        {moreCount > 0 && (
                                            <span
                                                className="showMore"
                                                onClick={() => showPopup(organizations)}
                                                style={{ cursor: 'pointer', color: '#007bff', fontSize: '12px' }}
                                            >
                                                +{moreCount} more
                                            </span>
                                        )}
                                    </div>
                                );
                            }
                        }
                    }
                    return <span style={{ color: '#999' }}>No Organizations</span>;
                },
            },
            {
                headerName: "",
                field: "is_active",
                minWidth: 120,
                sortable: true,
                suppressRowClickSelection: true,
                suppressMovable: true,
                cellRenderer: (params) => {
                    if (params) {
                        if (params.data) {
                            return <button className="edittext">
                                <div className="switch_btn_customize_box">
                                    {props.userCredentials?.user_details?.user_type === "app_admin" &&
                                        <BootstrapSwitchButton checked={params.data && params.data.is_active ? params.data.is_active : false}
                                            onChange={() => handleChangeSwitchButton(params)}
                                            onlabel='Active'
                                            onstyle='success'
                                            offlabel='Inactive'
                                            offstyle='danger'
                                            style='w-100 mx-3'
                                        />}
                                </div>
                            </button>
                        } else {
                            return null
                        }
                    } else {
                        return null
                    }
                },
            },
            {
                headerName: "",
                field: "edit",
                width: 90,
                suppressMovable: true,
                suppressRowClickSelection: true,
                cellRenderer: (params) => {
                    if (params.data && props.userCredentials.id != params.data?.id) {
                        return <div className="actionablePopupBox">
                            {props.userCredentials?.user_details?.user_type === "app_admin" &&
                                <button className="ellipsisIcon" onClick={(e) => actionModalfunction(e, params)}><i className="fa fa-ellipsis-v"></i></button>
                            }
                        </div>
                    } else {
                        return null;
                    }
                },
            }

        ]
    )

    const actionOutsideClickRef = useRef();
    const [searchUserName, setSearchUserName] = useState("");
    const [actionModalflag, setActionModalflag] = useState(false);
    const [overlayHight, setOverlayHight] = useState(0);
    const [overlayWidth, setOverlayWidth] = useState(0);
    const [gridObjData, setGridObjData] = useState({});
    const [selectedStatus, setSelectedStatus] = useState("");
    const [adminCreateModalFlag, setAdminCreateModalFlag] = useState(false);
    const [statusList, setStatusList] = useState([
        { label: "Active", value: "active" },
        { label: "Inactive", value: "inactive" },
    ]);
    const [hotelList, setHotelList] = useState([]);
    const [branchList, setBranchList] = useState([]);
    const [roleList, setRoleList] = useState([]);
    const [agentroleList, setAgentRoleList] = useState([]);
    const [hotelListData, setHotelListData] = useState([]);
    const [hotelSelectedValue, setHotelSelectedValue] = useState([]);
    const [branchSelectedValue, setBranchSelectedValue] = useState({});
    const [agentbranchSelectedValue, setAgentBranchSelectedValue] = useState({});
    const [roleSelectedValue, setRoleSelectedValue] = useState({});
    const [agentroleSelectedValue, setAgentRoleSelectedValue] = useState({});
    const [adminDetailsData, setAdminDetailsData] = useState([]);
    const [adminDetailsPopUpShowFlag, setAdminDetailsPopUpShowFlag] = useState(false);
    const [deleteConfirmationAlertModal, setDeleteConfirmationAlertModal] = useState(false);
    const [deleteBodySecondContent, setDeleteBodySecondContent] = useState("");
    const [staffDeleteObj, setStaffDeleteObj] = useState({});
    const [branchFilterList, setBranchFilterList] = useState([]);
    const [hotelBranchFilterSelectedValue, setHotelBranchFilterSelectedValue] = useState();
    const [isDisableRole, setIsDisableRole] = useState(true);
    const [selectedBranchId, setSelectedBranchId] = useState("");
    const [agentselectedBranchId, setAgentSelectedBranchId] = useState("");
    const [statusObjData, setStatusObjData] = useState({});
    const [peviouslySelectedBranchId, setPeviouslySelectedBranchId] = useState("");
    const [selectedRoleId, setSelectedRoleId] = useState("");
    const [agentselectedRoleId, setAgentSelectedRoleId] = useState("");
    const [peviouslySelectedRoleId, setPeviouslySelectedRoleId] = useState("");
    const [selectedUserId, setSelectedUserId] = useState("");
    const [phoneNumberCountryCode, setPhoneNumberCountryCode] = useState("in");
    const [phoneNumberDialCode, setPhoneNumberDialCode] = useState("91");
    const [isApiCalled, setIsApiCalled] = useState(false);
    const [formData, setFormData] = useState({
        "first_name": "",
        "last_name": "",
        "email": "",
        "contact_number": "",
        "profile_image": "",
        "hotel_branch": "",
        "hotel_name": [],
        "role": "",
        "agent_role": "",
        "agent_hotel_branch": "",
    })

    const [errorFormData, setErrorFormData] = useState({
        "first_name": "",
        "last_name": "",
        "email": "",
        "contact_number": "",
        "profile_image": "",
        "hotel_branch": "",
        "hotel_name": "",
        "role": "",
        "agent_role": "",
        "agent_hotel_branch": "",
    })
    const [addProfileImagePreviewShow, setAddProfileImagePreviewShow] = useState(false);
    const [imageCropModalFlag, setImageCropModalFlag] = useState(false);
    const [src, setSrc] = useState(null);
    const [addprofileImageSelected, setAddprofileImageSelected] = useState(require('../../../Utility/Public/images/profile-back.png'));
    const [crop, setCrop] = useState({
        unit: '%',
        width: 30,
    })
    const [croppedImageUrl, setCroppedImageUrl] = useState("");
    const imageRef = useRef();
    const [editedFlag, setEditedFlag] = useState(false);
    const [editedId, setEditedId] = useState("");
    const [editedRowData, setEditedRowData] = useState({});
    const [modalHeaderTitle, seModalHeaderTitle] = useState("");

    //user profile page details
    const [workercontentdisplay, setWorkercontentdisplay] = useState("");
    const [profilecontentdispaly, setProfilecontentdispaly] = useState("");
    const [tabcontainerspace, setTabcontainerspace] = useState("");
    const [userProfileId, setUserProfileId] = useState("");
    const [childProfileTabSelected, setChildProfileTabSelected] = useState("personal");
    const [showUserProfile, setShowUserProfile] = useState(false);
    const [selectedRowsData, setSelectedRowsData] = useState({});
    const [userSelectedPosition, setUserSelectedPosition] = useState(0);
    const [paramsData, setParamsData] = useState({});
    const [activeInActiveWorkerFilter, setActiveInActiveWorkerFilter] = useState(false);
    const [organizationFilterList, setOrganizationFilterList] = useState([]);
    const [organizationFilterSelectedValue, setOrganizationFilterSelectedValue] = useState("");
    const [zoominzoomoutflag, setZoominzoomoutflag] = useState("");
    const [gridRowData, setGridRowData] = useState({});
    const [showHistoryFlag, setShowHistoryFlag] = useState(false);
    const [staffHistoryData, setStaffHistoryData] = useState({});
    const [isAnimating, setIsAnimating] = useState(true);

    const gridRef = useRef();

    //unified cognito
    const [cognitoUser, setCognitoUser] = useState(null);
    const [cognitoUserConfirmationPopUpFlag, setCognitoUserConfirmationPopUpFlag] = useState(false);
    const onGridReady = useCallback((params) => {
        setgridparams(params)
        setGridApi(params.api)
        setGridColumnApi(params.columnApi)
        var datasource = serverSideDataSource()
        params.api.setDatasource(datasource);
    });

    //reset staff list 
    const resetDataGrid = (e = null) => {
        var datasource = serverSideDataSource(e)
        gridApi.setDatasource(datasource);
    }

    //staff list get api
    const serverSideDataSource = () => {
        return {
            getRows(params) {
                const { startRow, endRow, filterModel, sortModel } = params
                const { loaderStateTrue, loaderStateFalse } = props;
                setIsAnimating(true);
                loaderStateTrue();
                let filters = {};
                let filter_op = {};
                let globalQueryParamshash = {};
                globalQueryParamshash["offset"] = startRow;
                globalQueryParamshash["limit"] = parseInt(process.env.PAGE_DATA_LIMIT);
                /*if (['admin', 'staff'].includes(props.userCredentials.user_details.user_type)) {
                    globalQueryParamshash['user_type'] = "staff";
                } else {
                    //globalQueryParamshash['user_type'] = "staff";
                }*/
                if (['admin', 'staff'].includes(props.userCredentials.user_details.user_type)) {
                    globalQueryParamshash['user_type'] = "staff";
                } else {
                    if (props.userCredentials.user_details.user_type == "app_admin") {
                        globalQueryParamshash['user_type'] = ["admin"];
                    }
                }
                if (selectedStatus != "") {
                    globalQueryParamshash['is_active'] = selectedStatus.value == "active" ? true : false
                }
                // if (sortModel.length > 0) {
                //     const statusSortExists = sortModel.some(item => item.sort === "desc" || "asc" && item.colId === "is_active");
                //     if (!statusSortExists) {
                //         sortModel.push({ "sort": "desc", "colId": "is_active" });
                //     }
                //     globalQueryParamshash['sorting'] = sortModel;
                // } else {
                //     globalQueryParamshash['sorting'] = [{ "sort": "desc", "colId": "is_active" }];
                // }

                if (props.userCredentials && props.userCredentials.user_details && props.userCredentials.user_details.user_type != "app_admin") {
                    if (props.currentStore && props.currentStore.id) {
                        globalQueryParamshash["branch_id"] = props.currentStore.id;
                    }
                }
                if (hotelBranchFilterSelectedValue && hotelBranchFilterSelectedValue != "") {
                    globalQueryParamshash['branch_name'] = hotelBranchFilterSelectedValue.label
                    globalQueryParamshash["branch_id"] = hotelBranchFilterSelectedValue.value;
                }
                if (organizationFilterSelectedValue && organizationFilterSelectedValue != "") {
                    // globalQueryParamshash['organization_name'] = organizationFilterSelectedValue.label
                    globalQueryParamshash['org_id'] = organizationFilterSelectedValue.value
                }
                if (searchUserName != "") {
                    globalQueryParamshash['search_attr'] = searchUserName;
                    filter_op = Object.assign(filter_op, { "search_attr": "substring" });
                }

                if (Object.keys(filter_op).length > 0) {
                    filters["filter_op"] = JSON.stringify(filter_op);
                }
                filters['filters'] = JSON.stringify(globalQueryParamshash)
                let filterServerside = Object.keys(JSON.parse(filters.filters)).length > 0 ? filters : null;
                let userType = props.userCredentials.user_details.user_type;
                staffList(filterServerside, userType).then((response) => {
                    if (response.success) {
                        if (response.data.length == 0 && startRow == 0) {
                            gridRef.current.api.showNoRowsOverlay();
                        } else {
                            gridRef.current.api.hideOverlay();
                        }
                        params.successCallback(response.data, response.total);
                    } else {
                        params.failCallback();
                        Utility.toastNotifications("Something went wrong !", "Error", "error")
                    }
                    loaderStateFalse();
                    setIsAnimating(false);
                }).catch((error) => {
                    console.error("************error*************", error)
                    if (error) {
                    }
                    loaderStateFalse();
                    setIsAnimating(false);
                    if (error.message == "Network Error") {

                    }
                });
            }
        };
    }

    //get profile image get api fn
    const profileImageUi = (id) => {
        const promise = new Promise((resolve, reject) => {
            const { loaderStateTrue, loaderStateFalse } = props;
            loaderStateTrue();
            let data = {};
            data["filters"] = JSON.stringify(JSON.parse(process.env.THUMB_NAIL_SIZE))
            let userType = props.userCredentials.user_details.user_type;
            user_Details(id, data, userType).then((response) => {
                if (response.success) {
                    let responseUserDetails = response.data[0].user_details
                    if (responseUserDetails && Object.keys(responseUserDetails.profile_img).length > 0) {
                        resolve(responseUserDetails.profile_img.file_obj)
                    }
                    else {
                        resolve(responseUserDetails.profile_img)
                    }
                }
                loaderStateFalse();
            }).catch((error) => {
                console.error("************error*************", error)
                if (error) {
                }
                loaderStateFalse();
                if (error.message == "Network Error") {
                }
            });
        })
        return promise;

    }

    //aggrid grid option configuration
    const gridOptions = useMemo(
        () => ({
            infiniteInitialRowCount: 1,
            paginationPageSize: 100,
            rowBuffer: 0,
            rowModelType: 'infinite',
            suppressCellSelection: true,
            suppressHorizontalScroll: true,

        }),
        []
    )

    //search staff input handle change fn
    const handleSearchValue = (e) => {
        setSearchUserName(e.target.value)
    }

    //after changes in staff search , this useeffect call
    useEffect(() => {
        if (searchUserName != "") {
            resetDataGrid()
        }
        if (searchUserName.length == 0 && gridparams) {
            resetDataGrid()
        }
    }, [searchUserName])

    //clear staff search fn
    const clearSearchValue = () => {
        setSearchUserName("")
        resetDataGrid()
    }

    //action modal close on outside click
    useEffect(() => {
        const handleMouseDown = (event) => {
            handleClickOutside(event);
        };
        document.body.addEventListener('mousedown', handleMouseDown);
        return () => {
            document.body.removeEventListener('mousedown', handleMouseDown);
        };
    }, []);

    //staff hamburger icon onclick fn
    const actionModalfunction = (e, gridObj) => {
        if (gridObj.node) {
            gridObj.node.setSelected(false);
        }
        e.stopPropagation();
        let width = (parseInt(e.clientX) - 200) + 'px';
        let height = (parseInt(e.clientY) - 60) + 'px';
        setActionModalflag(true);
        setOverlayHight(height);
        setOverlayWidth(width);
        setGridObjData(gridObj);
    }

    //action modal close on outside click fn
    const handleClickOutside = (event) => {
        if (actionOutsideClickRef.current && !actionOutsideClickRef.current.contains(event.target)) {
            setActionModalflag(false);
            setOverlayHight(0);
            setOverlayWidth(0);
            setGridObjData({});
        }
        setStatusObjData({})
    };

    const showPopup = (relations) => {
        // Use a modal component to display the data
        setAdminDetailsData(relations);
        setAdminDetailsPopUpShowFlag(true);
    };

    const closeadminDetailsPopUpFn = () => {
        setAdminDetailsPopUpShowFlag(false);
        setAdminDetailsData([]);
        setZoominzoomoutflag("")
    }

    //staff edit fn
    const editStaff = (data) => {
        let selectedBranchId = data.data?.UserOrgBranchRoleRelation[0]?.branch_id
        let selectedRowsUserStatus = data.data?.hasOwnProperty('is_active') && data.data?.is_active
        if (selectedRowsUserStatus) {
            setAdminCreateModalFlag(true)
            seModalHeaderTitle(props.userCredentials?.user_details?.user_type == "app_admin" ? "Edit Admin" : "Edit User")
            setEditedFlag(true)
            allHotelsListApi()
            if (['admin', 'staff'].includes(props.userCredentials.user_details.user_type)) {
                let hotelId = props.userEntryType?.org_id;
                getHotelBranchListApi(hotelId);

                if (selectedBranchId) {
                    roleListGetApi(selectedBranchId).then((roleListData) => {
                        setIsDisableRole(false);
                        setRoleList(roleListData.length > 0 ? roleListData : []);
                    });
                    setIsApiCalled(true);
                }
            }


            setEditedId(data.data.id)
            setEditedRowData(data.data)
            setIsDisableRole(false)
            setIsApiCalled(false);
            let UserOrgBranchRoleRelationData = data.data.hasOwnProperty('UserOrgBranchRoleRelation') && data.data.UserOrgBranchRoleRelation ? data.data.UserOrgBranchRoleRelation : []
            let orgArr = []
            if (UserOrgBranchRoleRelationData.length > 0) {
                let org_obj = {}
                UserOrgBranchRoleRelationData.map((val, idx) => {
                    org_obj = {}
                    org_obj['label'] = val?.OrgUserRelation?.org_name
                    org_obj['id'] = val?.OrgUserRelation?.id
                    org_obj['value'] = val?.OrgUserRelation?.id
                    orgArr.push(org_obj);
                })
                setHotelSelectedValue(orgArr)
            } else {
                setHotelSelectedValue([])
            }
        } else {
            Utility.toastNotifications("The user's current status is inactive. Alter the user's status if you wish to make any changes to it.", "Warning", "warning")
        }
    }

    //set edit data on useeffect change 
    useEffect(() => {
        if (editedFlag) {
            setEditData()
        }
    }, [branchList, editedFlag, editedRowData])


    //staff active inactive status change fn
    const handleChangeSwitchButton = (params) => {
        setStatusObjData(params)
        if (params.node) {
            params.node.setSelected(false);
        }
        const { loaderStateTrue, loaderStateFalse } = props;
        let dataHash = {};
        let id = params.data.id
        dataHash["is_active"] = params.data.is_active ? false : true;
        loaderStateTrue()
        let userType = props.userCredentials.user_details.user_type;
        staffStatusUpdate(id, dataHash, userType).then((response) => {
            loaderStateFalse()
            if (response) {
                if (response.success) {
                    gridOptions.api.purgeInfiniteCache();
                    Utility.toastNotifications(response.message, "Success", "success");
                    resetDataGrid();
                    setStatusObjData({})
                } else {
                    gridOptions.api.purgeInfiniteCache();
                    Utility.toastNotifications(response.message, "Error", "error");
                    resetDataGrid();
                }
            }
        }).catch((error) => {
            if (error) {
            }
            loaderStateFalse();
            gridOptions.api.purgeInfiniteCache();
            if (error.message == "Network Error") {
            }
        });

    }

    //staff filter input onchange fn
    const handleChangeUserFilter = (type, event) => {
        if (type == 'status') {
            if (event) {
                setSelectedStatus(event)
            } else {
                setSelectedStatus("")
            }

        }
        if (type == 'branch') {
            if (event) {
                setHotelBranchFilterSelectedValue(event)
            } else {
                setHotelBranchFilterSelectedValue("")
            }
        }
        if (type == 'organization') {
            if (event) {
                setOrganizationFilterSelectedValue(event)
            } else {
                setOrganizationFilterSelectedValue("")
            }
        }
    }

    //status change useeffect hits
    useEffect(() => {
        if (gridApi && selectedStatus != "" && selectedStatus.hasOwnProperty('value')) {
            resetDataGrid();
        }
        if (gridApi && selectedStatus == "") {
            resetDataGrid();
        }
    }, [selectedStatus])

    //branch change useeffect hits
    useEffect(() => {
        if (gridApi && hotelBranchFilterSelectedValue != "" && hotelBranchFilterSelectedValue.hasOwnProperty('value')) {
            resetDataGrid();
        }
        if (gridApi && hotelBranchFilterSelectedValue == "") {
            resetDataGrid();
        }
    }, [hotelBranchFilterSelectedValue])

    //organization change useeffect hits
    useEffect(() => {
        if (gridApi && organizationFilterSelectedValue != "" && organizationFilterSelectedValue.hasOwnProperty('value')) {
            resetDataGrid();
        }
        if (gridApi && organizationFilterSelectedValue == "") {
            resetDataGrid();
        }
    }, [organizationFilterSelectedValue])

    //staff create fn
    const createAdminModalFn = () => {
        setAdminCreateModalFlag(true);
        seModalHeaderTitle(props.userCredentials?.user_details?.user_type == "app_admin" ? "Add Admin" : "Add User")
        allHotelsListApi();
        if (['admin', 'staff'].includes(props.userCredentials.user_details.user_type)) {
            let hotelId = props.userEntryType?.org_id;
            getHotelBranchListApi(hotelId);
        }
    }

    useEffect(() => {
        if (['admin', 'staff'].includes(props.userCredentials.user_details.user_type) && adminCreateModalFlag) {
            let organizationName = hotelListData.find(org => org.value === props.userEntryType.org_id);
            setHotelSelectedValue([organizationName])
            if (organizationName != undefined && Object.keys(organizationName).length > 0) {
                let tempFormData = { ...formData };
                let tempErrorFormData = { ...errorFormData }
                tempFormData["hotel_name"] = [organizationName];
                tempErrorFormData['hotel_name'] = "";
                setFormData(tempFormData)
                setErrorFormData(tempErrorFormData)
            }
        }
    }, [hotelListData, adminCreateModalFlag])

    //fetch organizations list on component mount
    useEffect(() => {
        allOrganizationsListApi();
    }, [])

    //agency role list get api
    const agentRoleListGetApi = (agencyId = "") => {
        const promise = new Promise((resolve, reject) => {
            const { loaderStateTrue, loaderStateFalse } = props;
            let data = {};
            let globalQueryParamshash = {};
            globalQueryParamshash["is_active"] = 1;
            if (agencyId != "") {
                globalQueryParamshash["hotel_id"] = agencyId;
            }
            data['filters'] = JSON.stringify(globalQueryParamshash)
            loaderStateTrue();
            let userType = props.userCredentials.user_details.user_type;
            roleListGet(data, userType).then((response) => {
                let roleListData = [];
                let roleListObj = {};
                if (response.data.length > 0) {
                    response.data.map((value, idx) => {
                        roleListObj = {};
                        roleListObj['label'] = value.name;
                        roleListObj['value'] = value.id;
                        roleListData.push(roleListObj)
                    })
                }
                resolve(roleListData)
                loaderStateFalse();
            }).catch((error) => {
                loaderStateFalse();

            });
        })
        return promise;
    }

    //all organizations list get api
    const allOrganizationsListApi = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let data = {};
        let globalQueryParamshash = {};
        globalQueryParamshash["is_active"] = 1;
        data['filters'] = JSON.stringify(globalQueryParamshash)
        loaderStateTrue();
        let userType = props.userCredentials.user_details.user_type;
        allHotelsList(data, userType).then((response) => {
            let organizationListData = [];
            let organizationListObj = {};
            if (response.data.length > 0) {
                response.data.map((value, idx) => {
                    organizationListObj = {};
                    organizationListObj['label'] = value.org_name;
                    organizationListObj['value'] = value.id;
                    organizationListData.push(organizationListObj)
                })
            }
            setOrganizationFilterList(organizationListData)
            loaderStateFalse();
        }).catch((error) => {
            loaderStateFalse();
            if (error) {
            }
            if (error.message == "Network Error") {
            }
        });
    }

    //close staff modal fn
    const closeAdminModal = () => {
        setAdminCreateModalFlag(false);
        seModalHeaderTitle("")
        resetFromData();
        setZoominzoomoutflag("")
        setGridRowData({})
        setEditedRowData({})
        setIsDisableRole(true)
        setRoleList([])
        setAgentRoleList([])
        setSelectedBranchId("")
        setSelectedRoleId("")
        setIsApiCalled(false)
    }

    //staff modal input field handle change
    const handelChange = (e, type, countryCode = {}) => {
        let tempFormData = { ...formData };
        let tempErrorFormData = { ...errorFormData }
        if (type == "first_name") {
            var expr = /^[a-zA-Z ]*$/;
            if (!expr.test(e.target.value)) {

            } else {
                if (e.target.value == "") {
                    tempErrorFormData['first_name'] = ""
                    tempFormData["first_name"] = ""
                } else {
                    tempFormData["first_name"] = e.target.value
                    tempErrorFormData['first_name'] = ""
                }
            }
        }
        if (type == "last_name") {
            var expr = /^[a-zA-Z ]*$/;
            if (!expr.test(e.target.value)) {

            } else {
                if (e.target.value == "") {
                    tempErrorFormData['last_name'] = ""
                    tempFormData["last_name"] = ""
                } else {
                    tempFormData["last_name"] = e.target.value
                    tempErrorFormData['last_name'] = ""
                }
            }
        }

        if (type == "email") {
            if (e.target.value != "") {
                let emailValidate = ValidateUtility.validate_email(e.target.value);
                if (emailValidate) {
                    tempFormData["email"] = e.target.value,
                        tempErrorFormData['email'] = ""
                } else {
                    tempFormData["email"] = e.target.value,
                        tempErrorFormData['email'] = "Enter valid email"
                }
            } else {
                tempFormData["email"] = "",
                    tempErrorFormData['email'] = ""
            }
        }

        if (type == "contact_number") {
            if (e.trim() !== "") {
                let modifiedString = ValidateUtility.deleteAndBefore(e, countryCode.dialCode);
                let countryCodeValue = countryCode.countryCode.toUpperCase();
                const phoneNumber = parsePhoneNumber(modifiedString, countryCodeValue);
                setPhoneNumberCountryCode(countryCode.countryCode)
                setPhoneNumberDialCode(countryCode.dialCode)
                if (phoneNumber && phoneNumber.isValid()) {
                    tempFormData["contact_number"] = e
                    tempErrorFormData['contact_number'] = ""
                } else {
                    tempFormData["contact_number"] = e
                    tempErrorFormData['contact_number'] = "Enter valid phone number"
                }
            } else {
                tempFormData["contact_number"] = "";
                tempErrorFormData['contact_number'] = "Required field";
            }
        }

        if (type == 'hotel_name') {
            if (e) {
                tempFormData["hotel_name"] = e;
                tempErrorFormData['hotel_name'] = "";
                setHotelSelectedValue(e)
            } else {
                tempFormData["hotel_name"] = [];
                tempErrorFormData['hotel_name'] = "Required Field";
                setHotelSelectedValue([])
            }
        }
        if (type == 'hotel_branch') {
            if (e) {
                tempFormData["hotel_branch"] = e;
                tempErrorFormData['hotel_branch'] = "";
                setBranchSelectedValue(e)
                tempFormData["role"] = "";
                setRoleSelectedValue({})
                setSelectedBranchId(e.value)
            } else {
                tempFormData["hotel_branch"] = "";
                tempErrorFormData['hotel_branch'] = "Required Field";
                setBranchSelectedValue({})
            }

            const branchId = e.value;
            if (branchId) {
                roleListGetApi(branchId).then((roleListData) => {
                    setIsDisableRole(false);
                    setRoleList(roleListData.length > 0 ? roleListData : []);
                });
                setIsApiCalled(true);
            }
        }
        if (type == 'agent_hotel_branch') {
            if (e) {
                tempFormData["agent_hotel_branch"] = e;
                tempErrorFormData['agent_hotel_branch'] = "";
                setAgentBranchSelectedValue(e)
                tempFormData["role"] = "";
                setAgentRoleSelectedValue({})
                setAgentSelectedBranchId(e.value)
            } else {
                tempFormData["agent_hotel_branch"] = "";
                tempErrorFormData['agent_hotel_branch'] = "Required Field";
                setAgentBranchSelectedValue({})
            }
        }

        if (type == 'role') {
            if (e) {
                tempFormData["role"] = e;
                tempErrorFormData['role'] = "";
                setRoleSelectedValue(e)
                setSelectedRoleId(e.value)
            } else {
                tempFormData["role"] = "";
                tempErrorFormData['role'] = "Required Field";
                setRoleSelectedValue({})

            }
        }

        if (type == 'agent_role') {
            if (e) {
                tempFormData["agent_role"] = e;
                tempErrorFormData['agent_role'] = "";
                setAgentRoleSelectedValue(e)
                setAgentSelectedRoleId(e.value)
            } else {
                tempFormData["agent_role"] = "";
                tempErrorFormData['agent_role'] = "Required Field";
                setAgentRoleSelectedValue({})

            }
        }

        setFormData(tempFormData)
        setErrorFormData(tempErrorFormData)
    }
    useEffect(() => {
    }, [agentroleSelectedValue])

    //reset staff modal form data
    const resetFromData = () => {
        setFormData({
            "first_name": "",
            "last_name": "",
            "email": "",
            "contact_number": "",
            "profile_image": "",
            "hotel_branch": "",
            "role": "",
            "hotel_name": []
        })
        setErrorFormData({
            "first_name": "",
            "last_name": "",
            "email": "",
            "contact_number": "",
            "profile_image": "",
            "hotel_branch": "",
            "role": "",
            "hotel_name": ''
        })
        setEditedFlag(false),
            setEditedId(""),
            setAddProfileImagePreviewShow(false),
            setImageCropModalFlag(false),
            setSrc(null),
            setAddprofileImageSelected(require('../../../Utility/Public/images/profile-back.png')),
            setCrop({
                unit: '%',
                width: 30,
            }),
            setCroppedImageUrl("")
        setBranchSelectedValue({})
        setRoleSelectedValue({})
        setIsDisableRole(true)
        setRoleList([])
        setAgentRoleList([])
        setPhoneNumberCountryCode("in")
        setPhoneNumberDialCode("91")
        setIsAlsoAgentAdmin(false)
        setHotelSelectedValue([])
    }

    //staff profile image upload handle change
    const addInputProfileImageChanged = (event) => {
        let tempformData = { ...formData };
        let temperrorFormData = { ...errorFormData };
        let targetFileSplit = event.target.files[0].name.split('.');
        let lastElement = targetFileSplit.pop();
        let user_profile_image = {
            "file_name": "",
            "file_obj": ""
        };
        const file = event.target.files[0];
        const allowedTypes = Utility.acceptFileType();
        Utility.checkFileType(file, allowedTypes)
            .then(results => {
                if (results.isValid) {
                    const fsize = event.target.files[0].size;
                    const fileSize = Math.round((fsize / 1024));
                    if (fileSize >= 300) {
                        Utility.toastNotifications(props.t('imageUploadAlert'), "Warning", "warning");
                    } else {
                        setImageCropModalFlag(true)
                        if (event.target.files && event.target.files.length > 0) {
                            const reader = new FileReader();
                            reader.addEventListener('load', () =>
                                setSrc(reader.result)
                            );
                            reader.readAsDataURL(event.target.files[0]);
                            user_profile_image["file_name"] = event.target.files[0].name
                            user_profile_image["file_obj"] = ""
                            tempformData['profile_image'] = user_profile_image
                            temperrorFormData['profile_image'] = ""
                            setAddProfileImagePreviewShow(true)
                        }
                    }
                } else {
                    tempformData['profile_image'] = "";
                    // temperrorFormData['profile_image'] = props.t('invalidField');
                    temperrorFormData['profile_image'] = 'Invalid field';
                    setAddProfileImagePreviewShow(false);
                    setAddprofileImageSelected('');
                    Utility.toastNotifications("File format is not supported, it should be in jpg, jpeg or png format", "Warning", "warning");
                }
            })
            .catch(error => {
                console.error("Error:", error);

            });

        setFormData(tempformData)
        setErrorFormData(temperrorFormData)

    }


    const getBase64 = (file, cb) => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
        };
    }

    //when uploaded image load
    const onImageLoaded = (image) => {
        if (image) {
            imageRef.current = image
        }
    };

    //after hit the crop button on crop image modal
    const onCropComplete = (crop) => {
        makeClientCrop(crop);
    };

    //crop area selection fn
    const onCropChange = (crop, percentCrop) => {
        setCrop(crop)
    };

    const makeClientCrop = async (crop) => {
        let tempformData = { ...formData };
        if (imageRef && crop.width && crop.height) {
            const croppedImageUrl = await getCroppedImg(
                imageRef.current,
                crop,
                'newFile.jpeg'
            );
            let user_profile_image = {}

            setAddprofileImageSelected(croppedImageUrl)
            user_profile_image["file_name"] = tempformData.profile_image.file_name
            user_profile_image["file_obj"] = croppedImageUrl
            tempformData["profile_image"] = user_profile_image
            setFormData(tempformData)
        }
    }

    const getCroppedImg = (image, crop, fileName) => {
        const canvas = document.createElement('canvas');
        const pixelRatio = window.devicePixelRatio;
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        const ctx = canvas.getContext('2d');

        canvas.width = crop.width * pixelRatio * scaleX;
        canvas.height = crop.height * pixelRatio * scaleY;

        ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        ctx.imageSmoothingQuality = 'high';

        ctx.drawImage(
            image,
            crop.x * scaleX,
            crop.y * scaleY,
            crop.width * scaleX,
            crop.height * scaleY,
            0,
            0,
            crop.width * scaleX,
            crop.height * scaleY
        );

        const base64Image = canvas.toDataURL('image/jpeg');
        return base64Image
    }

    //Image url crop
    const imageCropModalShow = () => {
        setImageCropModalFlag(true)
    }

    const imageCropModalHide = () => {
        formData['profile_image'] = "",
            errorFormData['profile_image'] = "",
            setImageCropModalFlag(false)
        setAddprofileImageSelected(require('../../../Utility/Public/images/profile-back.png'))
        setAddProfileImagePreviewShow(false),
            setSrc(null),
            setCrop({
                unit: '%',
                width: 30,
            }),
            setCroppedImageUrl("")
    }

    const imageCropDataSave = () => {
        setImageCropModalFlag(false)
    }

    useEffect(() => {
    }, [formData, errorFormData])

    //staff add edit form dataset create fn
    const formatingDataset = (isSame = false) => {
        let dataset = [];
        let hash = {}
        if (formData.first_name != "") {
            hash['first_name'] = (formData.first_name).trim();
        }
        if (formData.last_name != "") {
            hash['last_name'] = (formData.last_name).trim();
        }
        if (formData?.email?.trim()) {
            hash.email = formData.email.trim();
        }

        var phoneNumber = formData.contact_number
        var plusRemovePhoneNumber = phoneNumber.replace(/\+/g, '')
        if (formData.contact_number != "") {
            hash['contact_number'] = plusRemovePhoneNumber;
        }

        if (formData.profile_image != "") {
            hash['profile_img_url'] = formData.profile_image != "" ? formData.profile_image : "";
        }
        if (hotelSelectedValue.length > 0) {
            if (!editedFlag) {
                hash['org_ids'] = hotelSelectedValue.map(item => item.id);
            } else {
                // hash['selected_ids'] = hotelSelectedValue.map(item => item.id);
                hash['org_ids'] = hotelSelectedValue.map(item => item.id);
            }
        }
        if (!editedFlag) {
            hash['is_active'] = true
        }
        if (isSame) {
            // hash['is_same_credential'] = true;
            hash['first_name'] = cognitoUser?.first_name || '';
            hash['last_name'] = cognitoUser?.last_name || '';
            hash['contact_number'] = cognitoUser?.contact_number || '';
            hash['email'] = cognitoUser?.email || '';
        }
        if (['admin', 'staff'].includes(props.userCredentials.user_details.user_type)) {
            if (branchSelectedValue && Object.keys(branchSelectedValue).length > 0) {
                hash['branch_id'] = branchSelectedValue.value;
            }
            if (roleSelectedValue && Object.keys(roleSelectedValue).length > 0) {
                hash['role_id'] = roleSelectedValue.value;
            }
        }
        // if (['agent', 'agent_staff'].includes(props.userCredentials.user_details.user_type)) {
        //     if (isAlsoAgentAdmin) {
        //         let hotelId = props.userCredentials.user_details.hasOwnProperty('user_full_hotel_agency_details') && props.userCredentials.user_details.user_full_hotel_agency_details.hasOwnProperty('hotel_id') ? props.userCredentials.user_details.user_full_hotel_agency_details.hotel_id : "";
        //         if (!editedFlag) {
        //             if (Object.keys(agentbranchSelectedValue).length > 0) {
        //                 hash['agent_branch_id'] = agentbranchSelectedValue.value;
        //             }
        //             if (Object.keys(agentroleSelectedValue).length > 0) {
        //                 hash['agent_role_id'] = agentroleSelectedValue.value;
        //             }
        //         } else {
        //             hash['agent_branch_id'] = agentbranchSelectedValue.value;
        //             hash['agent_role_id'] = agentroleSelectedValue.value;
        //         }
        //         hash['agency_id'] = hotelId;
        //         hash['branch_id'] = 0;
        //     } else {
        //         hash['branch_id'] = 0;
        //     }
        // } else {
        //     if (!editedFlag) {
        //         if (Object.keys(branchSelectedValue).length > 0) {
        //             hash['branch_id'] = branchSelectedValue.value;
        //         }
        //     } else {
        //         hash['branch_id'] = branchSelectedValue.value;
        //     }
        // }
        // if (!editedFlag) {
        //     if (Object.keys(roleSelectedValue).length > 0) {
        //         hash['role_id'] = roleSelectedValue.value;
        //     }
        // } else {
        //     hash['role_id'] = roleSelectedValue.value;
        // }
        // if (['agent', 'agent_staff'].includes(props.userCredentials.user_details.user_type)) {
        //     hash['user_type'] = "agent_staff";
        // } else {
        //     hash['user_type'] = "staff";
        // }
        // hash['is_active'] = true
        // if (isAlsoAgentAdmin && props.userCredentials.user_details.user_type == 'admin') {
        //     let agencyId = props.userCredentials.user_details.hasOwnProperty('user_full_hotel_agency_details') && props.userCredentials.user_details.user_full_hotel_agency_details.hasOwnProperty('agency_id') ? props.userCredentials.user_details.user_full_hotel_agency_details.agency_id : "";

        //     hash['agency_id'] = agencyId;
        //     hash['agent_role_id'] = agentroleSelectedValue.value;
        // }
        dataset.push(hash)
        return dataset;
    }

    //staff add edit form submit validation check
    const validationFromData = () => {
        let tempFormData = { ...formData }
        let tempErrorFormData = { ...errorFormData }
        let valid = true
        if ((tempFormData.first_name).trim() == "") {
            tempErrorFormData['first_name'] = "Required field"
            valid = false
        }
        if ((tempFormData.last_name).trim() == "") {
            tempErrorFormData['last_name'] = "Required field"
            valid = false
        }
        if (tempFormData.contact_number == "" || tempFormData.contact_number == null) {
            tempErrorFormData['contact_number'] = "Required field"
            valid = false
        } else {
            let modifiedString = ValidateUtility.deleteAndBefore(tempFormData.contact_number, phoneNumberDialCode);
            let countryCodeValue = phoneNumberCountryCode.toUpperCase();
            const phoneNumber = parsePhoneNumber(modifiedString, countryCodeValue);
            if (phoneNumber && phoneNumber.isValid()) {
                tempErrorFormData['contact_number'] = ""
            } else {
                tempErrorFormData['contact_number'] = "Enter valid phone number"
                valid = false
            }
        }

        /*if (tempFormData.email.trim() == "") {
            tempErrorFormData['email'] = "Required field"
            valid = false
        } else {
            var expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
            if (!expr.test(tempFormData.email.trim())) {
                tempErrorFormData['email'] = `${props.t('validEmail')}`
                valid = false;
            } else {
                tempErrorFormData['email'] = ""
            }*/
        if (tempFormData.email && tempFormData.email.trim() !== "") {
            var expr = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
            if (!expr.test(tempFormData.email.trim())) {
                tempErrorFormData['email'] = `${props.t('validEmail')}`
                valid = false;
            } else {
                tempErrorFormData['email'] = ""
            }
        } else {
            tempErrorFormData['email'] = ""
        }
        if (['admin', 'staff'].includes(props.userCredentials.user_details.user_type)) {
            if (tempFormData.branch_name == "") {
                tempErrorFormData['branch_name'] = "Required field"
                valid = false
            } else {
                tempErrorFormData['hotel_branch'] = ''
            }
            if (tempFormData.role == "") {
                tempErrorFormData['role'] = "Required field"
                valid = false
            } else {
                tempErrorFormData['role'] = ''
            }
        }

        if (tempFormData.hotel_name == "") {
            tempErrorFormData['hotel_name'] = "Required field"
            valid = false
        } else {
            tempErrorFormData['hotel_name'] = ''
        }

        setErrorFormData(tempErrorFormData)
        return valid
    }

    useEffect(() => {
    }, [errorFormData])

    //staff add edit api fn
    const adminDataSave = (isSame = false) => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let vaildData = validationFromData();
        if (vaildData) {
            let data = formatingDataset(isSame);
            let type = 'post';
            let id = ""
            if (editedFlag) {
                id = editedId
                type = "patch";
                data = data[0];
                if (selectedBranchId != peviouslySelectedBranchId || selectedRoleId != peviouslySelectedRoleId) {
                    data['is_rolebranch_changed'] = true
                }
            }
            // return false
            loaderStateTrue();
            let userType = props.userCredentials.user_details.user_type;
            staffCreate(data, id, type, userType).then((response) => {
                if (type == "post") {
                    if (response.length > 0) {
                        response.map((data) => {
                            if (data.success) {
                                resetDataGrid();
                                closeAdminModal();
                                Utility.toastNotifications(data.message, "Success", "success")
                            } else {
                                Utility.toastNotifications(data.message, "Error", "error")
                                loaderStateFalse();
                            }
                        })
                    }
                } else {
                    if (response.success) {
                        resetDataGrid();
                        closeAdminModal();
                        Utility.toastNotifications(response.message, "Success", "success");
                        loaderStateFalse();
                    } else {
                        Utility.toastNotifications(response.message, "Error", "error")
                        loaderStateFalse();
                    }
                }
                loaderStateFalse();
            }).catch((error) => {
                props.loaderStateFalse();
                if (error.response.status == 409) {
                    if (error.response.data.success == false && error.response.data.message == 'Same credential exists with different parametes') {
                        setCognitoUser(error.response.data.data)
                        setCognitoUserConfirmationPopUpFlag(true)
                    }
                }
            });
        }
    }

    const sameCredentialFn = () => {
        setCognitoUserConfirmationPopUpFlag(false)
        adminDataSave(true)
    }

    const differentCredentialFn = () => {
        setCognitoUserConfirmationPopUpFlag(false)
        resetUserFromData();
    }

    const resetUserFromData = () => {
        setFormData((prev) => ({
            ...prev,
            first_name: '',
            last_name: '',
            email: '',
            contact_number: '91',
        }));

        setErrorFormData((prev) => ({
            ...prev,
            first_name: '',
            last_name: '',
            email: '',
            contact_number: '',
        }));
        setPhoneNumberCountryCode("in");
        setPhoneNumberDialCode("91");
    }
    //user profile function
    const backToWorker = () => {
        setWorkercontentdisplay("");
        setProfilecontentdispaly("");
        setTabcontainerspace("");
        setShowUserProfile(false)
        // props.setTabConatinerSpaceClass("")

        if (activeInActiveWorkerFilter) {
            setActiveInActiveWorkerFilter(false)
            resetDataGrid()

        } else {
            let filters = {};
            let globalQueryParamshash = {};
            globalQueryParamshash["offset"] = paramsData.startRow;
            globalQueryParamshash["limit"] = process.env.PAGE_DATA_LIMIT;
            filters['filters'] = JSON.stringify(globalQueryParamshash)
            let userType = props.userCredentials.user_details.user_type;
            individualUser(userProfileId, filters, userType).then((response) => {
                let dataArry = []
                if (response.success) {
                    if (response.data.length > 0) {
                        if (response.data[0].active) {
                            let promiseArr = []
                            response.data.map((item, index) => {
                                let promise = new Promise((resolve, reject) => {
                                    profileImageUi(item.id).then((data) => {
                                        item["profile_img_temp"] = data
                                        resolve(item)
                                    })
                                })
                                promiseArr.push(promise)
                            })

                            Promise.all(promiseArr).then((values) => {
                                if (gridApi) {
                                    gridApi.forEachNode((node, i) => {
                                        if (node && node.data) {
                                            if (node.data.id == userProfileId) {
                                                node.setSelected(false);
                                                let rowNode = gridApi.getRowNode(`${i}`);
                                                rowNode.updateData(values[0]);
                                                gridApi.ensureIndexVisible(i, 'top');
                                            }
                                        }
                                    })
                                }
                            });
                        } else {
                            resetDataGrid()
                        }
                    } else {
                        resetDataGrid()
                    }
                }

            })

        }
    }
    let deselectAllCalled = false;
    //staff aggrid onSelectionsChanged fn
    const onSelectionChanged = (event) => {
        let personalTabPermission = Object.keys(Utility.getRoleObjectByEventKey('user_profile')).length > 0 && (Utility.getRoleObjectByEventKey('user_profile').subeventKey.length > 0 && Utility.getRoleObjectByEventKey('user_profile').subeventKey[0].rules != "")
        let professionalTabPermission = Object.keys(Utility.getRoleObjectByEventKey('user_profile')).length > 0 && (Utility.getRoleObjectByEventKey('user_profile').subeventKey.length > 0 && Utility.getRoleObjectByEventKey('user_profile').subeventKey[1].rules != "")

        let selectedRowsUserStatus = gridApi.getSelectedRows().length > 0 && gridApi.getSelectedRows()[0].is_active
        const api = event.api;
        if (props.adminFilterShow && selectedRowsUserStatus == true) {
            if (props.adminFilterShow && personalTabPermission || props.adminFilterShow && professionalTabPermission) {
                if (gridApi.getSelectedRows().length > 0) {
                    const selectedRows = gridApi.getSelectedRows()[0].id;
                    setUserProfileId(selectedRows);
                    setSelectedRowsData(gridApi.getSelectedRows()[0]);
                    setUserSelectedPosition(gridApi.getSelectedNodes()[0].rowIndex);
                    setShowUserProfile(true);
                    // props.setTabConatinerSpaceClass("tabcontainerspace");
                    setWorkercontentdisplay("workercontentdisplay");
                    setProfilecontentdispaly("profilecontentdispaly");
                    setTabcontainerspace("tabcontainerspace");
                }
            }
        } else {
            if (!deselectAllCalled) {
                api.deselectAll();
                deselectAllCalled = true;
            }
            if (Object.keys(gridObjData).length > 0 && gridObjData.hasOwnProperty('column') && gridObjData.column.colId == 'edit' || Object.keys(statusObjData).length > 0 && statusObjData.hasOwnProperty('column') && statusObjData.column.colId == 'is_active') {
            } else {
                Utility.toastNotifications("The user's current status is inactive. Alter the user's status if you wish to make any changes to it.", "Warning", "warning");
            }
        }
    }

    //get hotel list api
    const allHotelsListApi = () => {
        const { loaderStateTrue, loaderStateFalse, userCredentials } = props;
        let filters = {}
        let globalQueryParamshash = {};
        if (['agent', 'agent_staff'].includes(props.userCredentials.user_details.user_type)) {
            globalQueryParamshash["list_by"] = "agency";
        } else {
            globalQueryParamshash["list_by"] = "hotel";
        }
        globalQueryParamshash["sort_by_name"] = true;
        filters['filters'] = JSON.stringify(globalQueryParamshash)
        loaderStateTrue();
        allHotelsList(filters).then((response) => {
            if (response.success) {
                let hotelListArr = [];
                let hotelListHash = {};
                if (response.data.length > 0) {
                    response.data.map((tempItem) => {
                        hotelListHash = {};
                        // if (userCredentials.user_details.hotel_id == tempItem.id) {
                        hotelListHash['label'] = tempItem?.org_name;
                        hotelListHash['value'] = tempItem.id;
                        hotelListHash['id'] = tempItem.id;
                        hotelListArr.push(hotelListHash)
                        // }
                    })
                    setHotelListData(hotelListArr)
                }
                // setHotelSelectedValue(hotelListHash)
                // if (['agent', 'agent_staff'].includes(props.userCredentials.user_details.user_type)) {
                loaderStateFalse();
                // }
            }

        }).catch((error) => {
            loaderStateFalse();
        });
    };

    //get branch list api according to hotel id
    const getHotelBranchListApi = (hotelId = "") => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let data = {};
        let filters = {};
        loaderStateTrue();
        let userType = props.userCredentials.user_details.user_type;
        // if (['agent', 'agent_staff'].includes(userType)) {
        //     data['tab'] = "active_list";
        // }
        if (hotelId != "") {
            data['org_id'] = hotelId
            // delete data.tab;
        }

        filters['filters'] = JSON.stringify(data);
        getHotelBranchList(filters, userType, hotelId).then((response) => {
            let hotelBranchResponse = Object.keys(response.data).length > 0 && response.data[Object.keys(response.data)[0]]?.OrgBranchOrgRelation.length > 0 ? response.data[Object.keys(response.data)[0]].OrgBranchOrgRelation : {}
            let branchListData = [];
            let branchListObj = {};
            hotelBranchResponse.filter(e => e.status === 1).map((e) => {
                branchListObj = {};
                // branchListObj['label'] = `${e.branch_name}`;
                branchListObj['label'] = `${e.name}`;
                branchListObj['value'] = e.id;
                branchListData.push(branchListObj)
            })
            if (branchListData.length > 0) {
                setBranchList(branchListData);
            }

            loaderStateFalse();
        }).catch((error) => {
            loaderStateFalse();

        });
    }

    useEffect(() => {
        // if (props.userCredentials.user_details.user_type === "admin" && adminCreateModalFlag && branchList.length === 1 && !isApiCalled) {
        if (['admin', 'staff'].includes(props.userCredentials.user_details.user_type) && adminCreateModalFlag && branchList.length === 1 && !isApiCalled) {
            const selectedBranch = branchList[0];

            if (selectedBranch != undefined && Object.keys(selectedBranch).length > 0) {
                let tempFormData = { ...formData };
                let tempErrorFormData = { ...errorFormData }
                tempFormData["branch_name"] = selectedBranch;
                tempErrorFormData['hotel_name'] = "";
                setFormData(tempFormData)
                setErrorFormData(tempErrorFormData)
            }

            setBranchSelectedValue(selectedBranch);
            const branchId = selectedBranch.value;
            if (branchId) {
                roleListGetApi(branchId).then((roleListData) => {
                    setIsDisableRole(false);
                    setRoleList(roleListData.length > 0 ? roleListData : []);
                });
                setIsApiCalled(true);
            }
        }
    }, [adminCreateModalFlag, branchList, isApiCalled, props.userCredentials.user_details.user_type]);

    //when agency branch change, agency branch role list get api hits
    useEffect(() => {
        if (agentselectedBranchId != "") {
            let agencyId = props.userCredentials.user_details.hasOwnProperty('user_full_hotel_agency_details') && props.userCredentials.user_details.user_full_hotel_agency_details.hasOwnProperty('agency_id') ? props.userCredentials.user_details.user_full_hotel_agency_details.agency_id : "";
            let hotelId = props.userCredentials.user_details.hasOwnProperty('user_full_hotel_agency_details') && props.userCredentials.user_details.user_full_hotel_agency_details.hasOwnProperty('hotel_id') ? props.userCredentials.user_details.user_full_hotel_agency_details.hotel_id : "";
            roleListGetApi(agentselectedBranchId, hotelId).then((roleListData) => {
                setIsDisableRole(false)
                if (roleListData.length > 0) {
                    setAgentRoleList(roleListData);
                } else {
                    setAgentRoleList([])
                }
            })
        }
    }, [agentselectedBranchId])


    //roleList Get Api fn
    const roleListGetApi = (selectedBranchId, hotelId = "") => {
        const promise = new Promise((resolve, reject) => {
            const { loaderStateTrue, loaderStateFalse } = props;
            let data = {};
            let globalQueryParamshash = {};
            globalQueryParamshash["is_active"] = 1;
            globalQueryParamshash["branch_id"] = selectedBranchId
            if (hotelId != "") {
                globalQueryParamshash["hotel_id"] = hotelId
            }
            data['filters'] = JSON.stringify(globalQueryParamshash)
            loaderStateTrue();
            roleListGet(data).then((response) => {
                let roleListData = [];
                let roleListObj = {};
                if (response.data.length > 0) {
                    response.data.map((value, idx) => {
                        roleListObj = {};
                        roleListObj['label'] = value.name;
                        roleListObj['value'] = value.id;
                        roleListData.push(roleListObj)
                    })
                }
                resolve(roleListData)
                loaderStateFalse();
            }).catch((error) => {
                loaderStateFalse();

            });
        })
        return promise;
    }

    //zoom in modal fn
    const zoominFunction = () => {
        let zoominzoomoutflag = "zoominzoomoutclassDialog"
        setZoominzoomoutflag(zoominzoomoutflag)
    }

    //zoom out modal fn
    const zoomoutFunction = () => {
        let zoominzoomoutflag = ""
        setZoominzoomoutflag(zoominzoomoutflag)
    }

    //delete staff fn
    const deleteStaff = (params) => {
        setDeleteConfirmationAlertModal(true)
        setDeleteBodySecondContent(params.data?.first_name + " " + params.data?.last_name)
        setStaffDeleteObj(params.data)
    }

    //delete staff confirmation modal close
    const deleteConfirmationModalHide = () => {
        setDeleteConfirmationAlertModal(false)
        setDeleteBodySecondContent("")
        setStaffDeleteObj({})
    }

    //delete staff confirmation modal confirm fn
    const deleteConfirmButton = () => {
        staffDeleteApi()
    }

    //delete staff confirmation modal cancel fn
    const deleteCancleButton = () => {
        deleteConfirmationModalHide();
    }

    //staff delete api fn
    const staffDeleteApi = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let data = {}
        data['id'] = [staffDeleteObj.id]
        loaderStateTrue();
        staffDelete(data).then((response) => {
            if (response[0].success) {
                resetDataGrid()
                deleteConfirmationModalHide()
                resetFromData()
                Utility.toastNotifications(response[0].data[0].message, "Success", "success")
            } else {
                Utility.toastNotifications(response[0].data[0].message, "Error", "error")
            }
            loaderStateFalse();
        }).catch((error) => {
            console.error("************error*************", error)
            loaderStateFalse();
            if (error.message == "Network Error") {

            }
        });
    }

    //staff data set in edit mode fn
    const setEditData = () => {
        let dataSet = editedRowData
        if (dataSet != "") {
            //let UserOrgBranchRoleRelationData = dataSet.hasOwnProperty('UserOrgBranchRoleRelation') ? dataSet.UserOrgBranchRoleRelation : ""
            // let branchListFilter = branchList.filter((el) => {
            //     return el.value == UserOrgBranchRoleRelationData[0].branch_id;
            // });

            // let selectedRole = {}
            // // if (UserOrgBranchRoleRelationData[0].hasOwnProperty('role_name') && UserOrgBranchRoleRelationData[0].hasOwnProperty('role_id')) {
            // //     selectedRole = { "label": UserOrgBranchRoleRelationData[0].role_name, "value": UserOrgBranchRoleRelationData[0].role_id }
            // // }

            setFormData({
                "first_name": dataSet.first_name != "" ? dataSet.first_name : "",
                "last_name": dataSet.last_name != "" ? dataSet.last_name : "",
                "email": dataSet.email != "" ? dataSet.email : "",
                "contact_number": dataSet.contact_number != "" ? dataSet.contact_number : ""
            })
            setAddprofileImageSelected(dataSet.profile_img_url != null && dataSet.profile_img_url != "" ? JSON.parse(dataSet.profile_img_url).img_url : require('../../../Utility/Public/images/profile-back.png'))
            setAddProfileImagePreviewShow(dataSet.profile_img_url != null && dataSet.profile_img_url != "" ? true : false)
            // setBranchSelectedValue(branchListFilter[0]);
            // setSelectedBranchId(UserOrgBranchRoleRelationData[0].branch_id);
            // setPeviouslySelectedBranchId(UserOrgBranchRoleRelationData[0].branch_id)
            // setPeviouslySelectedRoleId(UserOrgBranchRoleRelationData[0].role_id)
            // setSelectedRoleId(UserOrgBranchRoleRelationData[0].role_id)

            let userBranchRelationData = dataSet.UserOrgBranchRoleRelation || [];
            let branchName = {
                label: userBranchRelationData[0]?.branch_name || "",
                value: userBranchRelationData[0]?.branch_id || "",
            };
            setBranchSelectedValue(branchName);

            let userRoleRelationData = dataSet.UserOrgBranchRoleRelation || [];
            let roleName = {
                label: userRoleRelationData[0]?.role_name || "",
                value: userRoleRelationData[0]?.role_id || "",
            };
            setRoleSelectedValue(roleName);
        }
    }

    //======= add action permission ====//
    // Check multiple permissions at once
    const userAndCustomerPermissions = Utility.hasMultipleActionPermissions(
        'user_and_customer',
        'users',
        ['view', 'create', 'edit', 'delete', 'export', 'approve', 'receive', 'generate_invoice', 'change_status', 'accept', 'reject', 'KOT info', 'cancel', 'bill', 'bill_post', 'cancel_bill_post', 'invoice', 'close_register'],
        props.userCredentials.user_details.user_type
    );

    // Check if any actions are available for display in the table
    const hamburgerTableActions = userAndCustomerPermissions.view || userAndCustomerPermissions.edit || userAndCustomerPermissions.delete;

    useEffect(() => {
        if (staffRef.current) {
            staffRef.current = false;
            if (['admin', 'staff'].includes(props.userCredentials.user_details.user_type)) {
                setColumnDefs([
                    {
                        headerName: "",
                        field: "profile_img_temp",
                        maxWidth: 72,
                        suppressMovable: true,
                        cellRenderer: (params) => {
                            if (params && params?.data) {
                                if (params?.data && params?.data?.profile_img_url) {
                                    let parseImageUrl = JSON.parse(params?.data?.profile_img_url);
                                    return <div className="gridusericon">
                                        <img src={parseImageUrl.img_url} />
                                    </div>
                                } else {
                                    return <div className="gridusericon">
                                        <img src={require('../../../Utility/Public/images/usericon.png')} />
                                    </div>
                                }
                            } else {
                                return null
                            }
                        }
                    },
                    {
                        headerName: 'Name',
                        field: "name",
                        minWidth: 180,
                        sortable: true,
                        suppressMovable: true,
                        cellRenderer: (params) => {
                            if (params.data) {
                                let concatname = params?.data?.first_name + "" + params?.data?.last_name
                                if (params?.data?.first_name && params?.data?.first_name && concatname.length > 15) {
                                    return <div><span className="textrenderview">
                                        <OverlayTrigger overlay={<Tooltip>{params.data && params?.data?.first_name != "" ? Utility.displayNameFormat(params?.data?.first_name, params?.data?.last_name) : ""}</Tooltip>}>
                                            <span >
                                                {params.data && params?.data?.first_name != "" ? Utility.displayNameFormat(params?.data?.first_name, params?.data?.last_name) : ""}
                                            </span>
                                        </OverlayTrigger>
                                    </span></div>
                                } else {
                                    return (<div><span className="textrenderview">{params?.data && params?.data?.first_name != "" ? Utility.displayNameFormat(params?.data?.first_name, params?.data?.last_name) : ""}</span></div>)
                                }

                            } else {
                                return null;
                            }
                        },
                    },
                    {
                        headerName: 'Store Name',
                        field: "branch_name",
                        minWidth: 150,
                        sortable: true,
                        suppressMovable: true,
                        cellRenderer: (params) => {
                            if (params.data) {
                                if (params.data.hasOwnProperty('UserOrgBranchRoleRelation') && params.data.UserOrgBranchRoleRelation) {
                                    if (params?.data?.UserOrgBranchRoleRelation && Array.isArray(params?.data?.UserOrgBranchRoleRelation) && params?.data.UserOrgBranchRoleRelation.length > 0) {

                                        if (params.data.UserOrgBranchRoleRelation[0]?.branch_name && params.data.UserOrgBranchRoleRelation[0]?.branch_name.length >= 20) {
                                            return <div className="textrenderview">
                                                <OverlayTrigger overlay={<Tooltip>{params.data.UserOrgBranchRoleRelation[0]?.branch_name ? params.data.UserOrgBranchRoleRelation[0]?.branch_name : null}</Tooltip>}>
                                                    <span >{(params.data.UserOrgBranchRoleRelation[0]?.branch_name)?.substring(0, 17) + "..."}</span>
                                                </OverlayTrigger>
                                            </div>
                                        } else {
                                            return <div className="textrenderview">
                                                <div>{params.data.UserOrgBranchRoleRelation[0]?.branch_name ? params.data.UserOrgBranchRoleRelation[0]?.branch_name : ""}</div>
                                            </div>
                                        }
                                    } else {
                                        return null;
                                    }
                                } else {
                                    return null;
                                }
                            } else {
                                return null;
                            }
                        },
                    },
                    {
                        headerName: 'Designation',
                        field: "role_name",
                        minWidth: 150,
                        sortable: true,
                        suppressMovable: true,
                        cellRenderer: (params) => {
                            if (params.data) {
                                if (params.data.hasOwnProperty('UserOrgBranchRoleRelation') && params.data.UserOrgBranchRoleRelation) {
                                    if (params.data.UserOrgBranchRoleRelation) {
                                        return <div><span className="textrenderview">
                                            <OverlayTrigger overlay={<Tooltip>{params.data.UserOrgBranchRoleRelation[0]?.role_name}</Tooltip>}>
                                                <span >{params.data.UserOrgBranchRoleRelation[0]?.role_name}</span>
                                            </OverlayTrigger>
                                        </span></div>
                                    } else {
                                        return null;
                                    }
                                } else {
                                    return null;
                                }
                            } else {
                                return null;
                            }
                        },
                    },
                    {
                        headerName: 'Email',
                        field: "email",
                        minWidth: 250,
                        sortable: true,
                        suppressMovable: true,
                        cellRenderer: (params) => {
                            if (params.data) {
                                const email = params.data.email ? params.data.email.split('#')[0] : '';
                                if (email && email.length > 20) {
                                    return <div><span className="textrenderview">
                                        <OverlayTrigger trigger={['hover', 'click']} rootClose={true} overlay={<Tooltip>{email}</Tooltip>}>
                                            <span >{email}</span>
                                        </OverlayTrigger>
                                    </span></div>
                                } else {
                                    return <div><span className="textnowrapview">{email}</span></div>
                                }
                            } else {
                                return null;
                            }
                        },
                    },
                    {
                        headerName: 'Phone Number',
                        field: "contact_number",
                        minWidth: 150,
                        sortable: true,
                        suppressMovable: true,
                        cellRenderer: (params) => {
                            if (params.data) {
                                const contactNumber = params?.data?.contact_number ? params?.data?.contact_number.split('#')[0] : '';
                                if (contactNumber) {
                                    return <div><span >{contactNumber}</span></div>
                                } else {
                                    return null;
                                }
                            } else {
                                return null;
                            }
                        },
                    },
                    {
                        headerName: "",
                        field: "is_active",
                        minWidth: 110,
                        sortable: true,
                        suppressRowClickSelection: true,
                        suppressMovable: true,
                        cellRenderer: (params) => {
                            if (params && userAndCustomerPermissions.change_status) {
                                if (params.data) {
                                    return <button className="edittext">
                                        <div className="switch_btn_customize_box">
                                            {(props.userCredentials?.user_details?.user_type === "admin" ||
                                                (Object.keys(Utility.getRoleObjectByEventKey('user_and_customer')).length > 0 && (Utility.getRoleObjectByEventKey('user_and_customer').subeventKey.length > 0 && Utility.getRoleObjectByEventKey('user_and_customer').subeventKey[0].eventKey == "users" && (Utility.getRoleObjectByEventKey('user_and_customer').subeventKey[0].rules == "CRUD" || Utility.getRoleObjectByEventKey('user_and_customer').subeventKey[0].rules == "CUD")))) &&
                                                <BootstrapSwitchButton checked={params.data && params.data.is_active ? params.data.is_active : false}
                                                    onChange={() => handleChangeSwitchButton(params)}
                                                    onlabel='Active'
                                                    onstyle='success'
                                                    offlabel='Inactive'
                                                    offstyle='danger'
                                                    style='w-100 mx-3'
                                                />
                                            }
                                        </div>
                                    </button>
                                } else {
                                    return null
                                }
                            } else {
                                return null
                            }
                        },
                    },
                    {
                        headerName: "",
                        field: "edit",
                        width: 90,
                        suppressMovable: true,
                        suppressRowClickSelection: true,
                        cellRenderer: (params) => {
                            // if (params.data && props.userCredentials.id != params.data?.id) {
                            if (params.data) {
                                return <div className="actionablePopupBox">
                                    {(props.userCredentials?.user_details?.user_type === "admin" ||
                                        (Object.keys(Utility.getRoleObjectByEventKey('user_and_customer')).length > 0 && (Utility.getRoleObjectByEventKey('user_and_customer').subeventKey.length > 0 && Utility.getRoleObjectByEventKey('user_and_customer').subeventKey[0].eventKey == "users" && (Utility.getRoleObjectByEventKey('user_and_customer').subeventKey[0].rules == "CRUD" || Utility.getRoleObjectByEventKey('user_and_customer').subeventKey[0].rules == "CUD")))) && hamburgerTableActions &&
                                        <button className="ellipsisIcon" onClick={(e) => actionModalfunction(e, params)}><i className="fa fa-ellipsis-v"></i></button>
                                    }
                                </div>
                            } else {
                                return null;
                            }
                        },
                    }

                ])
                hotelBranchFilterListApi();
            } else {
                // hotelBranchFilterListApi();
            }
        }
    }, [])

    //get hotel branch list api
    const hotelBranchFilterListApi = () => {
        const { loaderStateTrue, loaderStateFalse } = props;
        let data = {};
        let filters = {};
        loaderStateTrue();
        let userType = props.userCredentials.user_details.user_type;
        if (['agent', 'agent_staff'].includes(userType)) {
            data['tab'] = "active_list";
            filters['filters'] = JSON.stringify(data);
        }
        // getHotelBranchList(filters, userType).then((response) => {
        //     let hotelBranchResponse = Object.keys(response.data).length > 0 && response.data[Object.keys(response.data)[0]]?.OrgBranchOrgRelation.length > 0 ? response.data[Object.keys(response.data)[0]].OrgBranchOrgRelation : {}
        //     let branchListData = [];
        //     let branchListObj = {};
        //     hotelBranchResponse.map((e) => {
        //         branchListObj = {};
        //         // branchListObj['label'] = `${e.branch_name}`;
        //         branchListObj['label'] = `${e.name}`;
        //         branchListObj['value'] = e.id;
        //         branchListData.push(branchListObj)
        //     })
        //     if (branchListData.length > 0) {
        //         console.log("7777",branchListData)
        //         console.log("7777",props.currentStore)

        //         setBranchFilterList(branchListData);
        //     }
        //     loaderStateFalse();
        // })
        getStoreList(filters, userType, "", props.currentStore?.slack).then((response) => {
            let hotelBranchResponse = response.data || [];
            let branchListData = [];
            let branchListObj = {};
            hotelBranchResponse.map((e) => {
                branchListObj = {};
                branchListObj['label'] = `${e.name}`;
                branchListObj['value'] = e.id;
                branchListData.push(branchListObj)
            })
            if (branchListData.length > 0) {
                setBranchFilterList(branchListData);
            }
            loaderStateFalse();
        }).catch((error) => {
            loaderStateFalse();

        });
    }

    //show staff history modal fn
    const showStaffHistory = (data) => {
        seModalHeaderTitle("User History")
        if (data.data.UserOrgBranchRoleRelation && data.data.UserOrgBranchRoleRelation[0].hasOwnProperty('user_id')) {
            setSelectedUserId(data.data.UserOrgBranchRoleRelation[0].user_id)
            setShowHistoryFlag(true)
        }
    }

    //close staff history modal fn
    const closeHistoryModal = () => {
        setShowHistoryFlag(false);
        seModalHeaderTitle("")
        setZoominzoomoutflag("")
    }

    const noRowsOverlayComponent = useMemo(() => {
        return CustomNoRowsOverlay;
    }, []);

    //staff grid reload function
    const loadGrid = () => {
        resetDataGrid();
    }

    //if this admin also an agency admin then this useeffect perform 
    // useEffect(() => {
    //     if (isAlsoAgentAdmin) {
    //         let agencyId = props.userCredentials.user_details.hasOwnProperty('user_full_hotel_agency_details') && props.userCredentials.user_details.user_full_hotel_agency_details.hasOwnProperty('agency_id') ? props.userCredentials.user_details.user_full_hotel_agency_details.agency_id : "";

    //         let hotelId = props.userCredentials.user_details.hasOwnProperty('user_full_hotel_agency_details') && props.userCredentials.user_details.user_full_hotel_agency_details.hasOwnProperty('hotel_id') ? props.userCredentials.user_details.user_full_hotel_agency_details.hotel_id : "";

    //         if (['agent', 'agent_staff'].includes(props.userCredentials.user_details.user_type)) {
    //             getHotelBranchListApi(hotelId);
    //         } else {
    //             agentRoleListGetApi(agencyId).then((roleListData) => {
    //                 if (roleListData.length > 0) {
    //                     setAgentRoleList(roleListData);
    //                 } else {
    //                     setAgentRoleList([])
    //                 }
    //             })
    //         }
    //     }
    // }, [isAlsoAgentAdmin])

    useEffect(() => {
        if (cognitoUserConfirmationPopUpFlag) {
            const timer = setTimeout(() => {
                const backdrops = document.querySelectorAll('.modal-backdrop');

                // only target LAST backdrop (top-most modal)
                const latestBackdrop = backdrops[backdrops.length - 1];

                if (latestBackdrop) {
                    latestBackdrop.classList.add('my-custom-backdrop');
                }
            }, 10);

            return () => clearTimeout(timer);
        } else {
            const backdrops = document.querySelectorAll('.modal-backdrop');
            backdrops.forEach((el) => {
                el.classList.remove('my-custom-backdrop');
            });
        }
    }, [cognitoUserConfirmationPopUpFlag]);

    return (
        <div className={`${`gridcontainer userGridContainer`}`}>
            <div className={`${workercontentdisplay} totalworkercontent`}>
                {props.adminFilterShow &&
                    <>
                        <div className="gridtopviews gridtopviewsHistory gridtopviewsAllSectionBox">
                            <div className="rightboxesSec">
                                {(props.userCredentials?.user_details?.user_type === "app_admin" ||
                                    props.userCredentials?.user_details?.user_type === "admin" ||
                                    (Object.keys(Utility.getRoleObjectByEventKey('user_and_customer')).length > 0 && (Utility.getRoleObjectByEventKey('user_and_customer').subeventKey.length > 0 && Utility.getRoleObjectByEventKey('user_and_customer').subeventKey[0].eventKey == "users" && (Utility.getRoleObjectByEventKey('user_and_customer').subeventKey[0].rules == "CRUD" || Utility.getRoleObjectByEventKey('user_and_customer').subeventKey[0].rules == "CUD")))) && userAndCustomerPermissions.create && (
                                        <CustomButton
                                            onClick={createAdminModalFn}
                                            className="customButtonClassBox"
                                            children="Add"
                                        />
                                    )}
                            </div>
                        </div>
                        <div className='filterSectionBox'>
                            <div className="gridtopviews gridtopviewsHistory">
                                <div className="dropdownBoxContainer statusdropcontainerBox">
                                    <AutosuggestComponent
                                        handleOnChange={(e) => { handleChangeUserFilter('status', e) }}
                                        options={statusList}
                                        selectedValue={selectedStatus}
                                        name=''
                                        isMulti={false}
                                        placeholder="Status"
                                        isDisabled={false}
                                        isClearable={true}
                                        closeButton={false}
                                        menuHeader="Status"
                                        isSearchable={true}

                                    />
                                </div>
                                {props.userCredentials?.user_details?.user_type != "app_admin" &&
                                    <div className="dropdownBoxContainer branchDropdownBox">
                                        <AutosuggestComponent
                                            handleOnChange={(e) => { handleChangeUserFilter('branch', e) }}
                                            options={branchFilterList}
                                            selectedValue={hotelBranchFilterSelectedValue}
                                            name=''
                                            isMulti={false}
                                            placeholder="Store"
                                            isDisabled={false}
                                            isClearable={true}
                                            closeButton={false}
                                            menuHeader="Store"
                                            isSearchable={true}

                                        />
                                    </div>}
                                {(props.userCredentials?.user_details?.user_type === "app_admin") && <div className="dropdownBoxContainer organizationDropdownBox">
                                    <AutosuggestComponent
                                        handleOnChange={(e) => { handleChangeUserFilter('organization', e) }}
                                        options={organizationFilterList}
                                        selectedValue={organizationFilterSelectedValue}
                                        name=''
                                        isMulti={false}
                                        placeholder="Organization"
                                        isDisabled={false}
                                        isClearable={true}
                                        closeButton={false}
                                        menuHeader="Organization"
                                        isSearchable={true}

                                    />
                                </div>}
                                <div className="pageinnersearchBox staff">
                                    <button type="button" className="btn btn-link search_btn_addon"><i className="fa fa-search"></i></button>
                                    <DebounceInput
                                        minLength={2}
                                        debounceTimeout={500}
                                        onChange={(e) => handleSearchValue(e)}
                                        placeholder={props.userCredentials?.user_details?.user_type == "app_admin" ? "Search an admin" : "Search an user"}
                                        value={searchUserName}
                                        autoComplete="off"
                                    />
                                    {searchUserName != "" ?
                                        < button type="button" className="btn btn-link dropclosebtn"
                                            onClick={clearSearchValue}
                                        >
                                            <img src={require('../../../Utility/Public/images/dropcloseicon.png')} className="searchClearIcon" />
                                        </button>
                                        : null}
                                </div>
                            </div>
                        </div>
                    </>
                }
                <div className='grid_content_inner'>
                    <div className="ag-theme-alpine aggridviewSection" style={{ position: 'relative' }}>
                        <div className="leadButtonInnerBox"><button className="buttonload" onClick={() => { loadGrid() }} data-tip="Refresh"><RefreshButton
                            isAnimating={isAnimating}
                        />
                        </button>
                            <ReactTooltip place="bottom" />
                        </div>
                        <AgGridReact
                            modules={modules}
                            columnDefs={columnDefs}
                            defaultColDef={defaultColDef}
                            components={components}
                            rowSelection="single"
                            rowModelType="infinite"
                            onGridReady={onGridReady}
                            rowHeight={43.9}
                            headerHeight={40.8}
                            cacheBlockSize={process.env.PAGE_DATA_LIMIT}
                            gridOptions={gridOptions}
                            onSelectionChanged={(e) => { onSelectionChanged(e) }}
                            noRowsOverlayComponent={noRowsOverlayComponent}
                            ref={gridRef}
                        />
                    </div>
                </div>
            </div>
            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={adminCreateModalFlag}
                    onHide={closeAdminModal}
                    title={modalHeaderTitle}
                    className={` ${zoominzoomoutflag + ' ' + "modalcustomizeDialog mondimension usersModalDialog"}`}
                    footer={false}
                    closeButton={true}
                    saveButtonLabel="Confirm"
                    saveButtonClassName="btn btn-primary savebtn"
                    onSave={adminDataSave}
                    cancelShow={true}
                    zoominButton={zoominzoomoutflag != "" ? false : true}
                    zoomoutButton={zoominzoomoutflag != "" ? true : false}
                    zoomin={zoominFunction}
                    zoomout={zoomoutFunction}

                    body={
                        <>
                            <ErrorBoundary title="CampaignBroadcastingModalContent Error">
                                <UserAddEditModalContent
                                    closeAdminModal={closeAdminModal}
                                    handelChange={handelChange}
                                    formData={formData}
                                    errorFormData={errorFormData}
                                    adminDataSave={adminDataSave}
                                    crop={crop}
                                    croppedImageUrl={croppedImageUrl}
                                    src={src}
                                    onImageLoaded={onImageLoaded}
                                    onCropComplete={onCropComplete}
                                    onCropChange={onCropChange}
                                    imageCropModalShow={imageCropModalShow}
                                    imageCropModalHide={imageCropModalHide}
                                    imageCropModalFlag={imageCropModalFlag}
                                    imageCropDataSave={imageCropDataSave}
                                    addprofileImageSelected={addprofileImageSelected}
                                    addInputProfileImageChanged={addInputProfileImageChanged}
                                    addProfileImagePreviewShow={addProfileImagePreviewShow}
                                    hotelListData={hotelListData}
                                    hotelSelectedValue={hotelSelectedValue}
                                    branchSelectedValue={branchSelectedValue}
                                    roleSelectedValue={roleSelectedValue}
                                    hotelList={hotelList}
                                    branchList={branchList}
                                    roleList={roleList}
                                    editedFlag={editedFlag}
                                    isDisableRole={isDisableRole}
                                    phoneNumberCountryCode={phoneNumberCountryCode}
                                    hasAdminAndAgent={props.userGroup.includes("admin") && props.userGroup.includes("agent")}
                                    setIsAlsoAgentAdmin={setIsAlsoAgentAdmin}
                                    isAlsoAgentAdmin={isAlsoAgentAdmin}
                                    agentroleList={agentroleList}
                                    agentroleSelectedValue={agentroleSelectedValue}
                                    agentbranchSelectedValue={agentbranchSelectedValue}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>

            {actionModalflag ?
                <>
                    <ErrorBoundary title="GridActionContent Error">
                        <GridActionContent
                            styleWidth={overlayWidth}
                            styleHight={overlayHight}
                            codeOutsideClickRef={actionOutsideClickRef}
                            gridObjData={gridObjData}
                            modefier={editStaff}
                            delete={deleteStaff}
                            archivedButtonShow={false}
                            hostory={showStaffHistory}
                            editButtonShow={(props.userCredentials?.user_details?.user_type === "app_admin" ||
                                props.userCredentials?.user_details?.user_type === "admin" ||
                                (Object.keys(Utility.getRoleObjectByEventKey('user_and_customer')).length > 0 && (Utility.getRoleObjectByEventKey('user_and_customer').subeventKey.length > 0 && Utility.getRoleObjectByEventKey('user_and_customer').subeventKey[0].eventKey == "users" && (Utility.getRoleObjectByEventKey('user_and_customer').subeventKey[0].rules == "CRUD" || Utility.getRoleObjectByEventKey('user_and_customer').subeventKey[0].rules == "CUD")))) && userAndCustomerPermissions.edit ? true : false}
                            deleteButtonShow={false}
                            staffHistoryButtonShow={false}
                        />
                    </ErrorBoundary>
                </>
                : null}

            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={deleteConfirmationAlertModal}
                    onHide={deleteConfirmationModalHide}
                    className="modalcustomize confirmationalertmodal"
                    bodyClassName="cancelConfirmationbody"
                    headerclassName="close_btn_icon"
                    title="Delete This Staff?"
                    footer={false}
                    body={
                        <>
                            <ErrorBoundary title="ConfirmationAlert Error">
                                <ConfirmationAlert
                                    BodyFirstContent="Do you confirm the deletion of the"
                                    BodySecondContent={deleteBodySecondContent}
                                    BodyThirdContent="staff definitely? You won't be able to go back."
                                    confirmationButtonContent="Confirm"
                                    cancelButtonContent="Cancel"
                                    deleteConfirmButton={deleteConfirmButton}
                                    deleteCancleButton={deleteCancleButton}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>

            {showUserProfile &&
                <>
                    <ErrorBoundary title="UserProfile Error">
                        <UserProfile
                            profilecontentdispaly={profilecontentdispaly}
                            backToWorker={backToWorker}
                            userProfileId={userProfileId}
                            detectChangesIndividualTab={props.detectChangesIndividualTab}
                            selectedRowsData={selectedRowsData}
                            paramsData={paramsData}
                        />
                    </ErrorBoundary>
                </>}
            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={showHistoryFlag}
                    onHide={closeHistoryModal}
                    title={modalHeaderTitle}
                    className={` ${zoominzoomoutflag + ' ' + "modalcustomize mondimension userHistoryModalContent"}`}
                    footer={false}
                    closeButton={true}
                    saveButtonLabel="Confirm"
                    saveButtonClassName="btn btn-primary savebtn"
                    cancelShow={true}
                    zoominButton={zoominzoomoutflag != "" ? false : true}
                    zoomoutButton={zoominzoomoutflag != "" ? true : false}
                    zoomin={zoominFunction}
                    zoomout={zoomoutFunction}
                    body={
                        <>
                            <ErrorBoundary title="UserHistoryModalContent Error">
                                <UserHistoryModalContent
                                    closeHistoryModal={closeHistoryModal}
                                    selectedUserId={selectedUserId}
                                    branchFilterList={branchFilterList}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>

            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={adminDetailsPopUpShowFlag}
                    onHide={closeadminDetailsPopUpFn}
                    title="Organization Details"
                    // className={` ${zoominzoomoutflag + ' ' + "modalcustomize mondimension adminDetailsModalContent"}`}
                    className="modalcustomize mondimension multiDetailsDialog"
                    footer={false}
                    closeButton={true}
                    saveButtonLabel="Confirm"
                    saveButtonClassName="btn btn-primary savebtn modbtn"
                    cancelShow={true}
                    cancelButtonLabel={"Cancel"}
                    cancelButtonClassName="modbtn cancelbtn"
                    footerClassName="text-center topspace"
                    body={
                        <>
                            <ErrorBoundary title="admin details error">
                                <div className='multidetailsContainer'>
                                    {adminDetailsData.length > 0 && adminDetailsData.map((org, index) => (
                                        <div key={index} className="adminDetail">
                                            <p className='detailsLabel name'>
                                                <strong>Organization:</strong>{" "}
                                                {org?.OrgUserRelation?.org_name || 'N/A'}
                                            </p>
                                            <p className='detailsLabel email'>
                                                <strong>Role:</strong> {org?.role_name || 'N/A'}
                                            </p>
                                            <p className='detailsLabel contact'>
                                                <strong>Branch:</strong>{" "}
                                                {org?.branch_name || 'All Branches'}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>

            <ErrorBoundary title="ModalGlobal Error">
                <ModalGlobal
                    show={cognitoUserConfirmationPopUpFlag}
                    onHide={() => setCognitoUserConfirmationPopUpFlag(false)}
                    className="modalcustomize confirmationalertmodal confirmationalertmodalUnifiedCognito"
                    bodyClassName="cancelConfirmationbody"
                    headerclassName="close_btn_icon"
                    title="User Confirmation"
                    footer={false}
                    closeButton={true}
                    body={
                        <>
                            <ErrorBoundary title="ConfirmationAlert Error">
                                <ConfirmationAlert
                                    BodyFirstContent={<>
                                        <p>Do you want to use the same credentials for this user?</p>
                                    </>}
                                    BodySecondContent={<>
                                        <div class="user-info-card">
                                            <div class="user-info-row">
                                                <span class="label">First Name</span>
                                                <span class="value">{`${cognitoUser?.first_name}` || ""}</span>
                                            </div>
                                            <div class="user-info-row">
                                                <span class="label">Last Name</span>
                                                <span class="value">{`${cognitoUser?.last_name}` || ""}</span>
                                            </div>
                                            <div class="user-info-row">
                                                <span class="label">Phone Number</span>
                                                <span class="value">{cognitoUser?.contact_number ? cognitoUser?.contact_number.includes('+') ? cognitoUser?.contact_number : '+' + cognitoUser?.contact_number : ''}</span>
                                            </div>
                                            {cognitoUser?.email ?
                                                <div class="user-info-row">
                                                    <span class="label">Email</span>
                                                    <span class="value">{cognitoUser?.email || ''}</span>
                                                </div>
                                                : null}
                                        </div>

                                    </>}
                                    BodyThirdContent={''}
                                    confirmationButtonContent="Same Credential"
                                    cancelButtonContent="Different Credential"
                                    deleteConfirmButton={sameCredentialFn}
                                    deleteCancleButton={differentCredentialFn}
                                />
                            </ErrorBoundary>
                        </>
                    }
                />
            </ErrorBoundary>
        </div >
    );
};

Users.defaultProps = {
    adminFilterShow: true
}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials,
        token: globalState.LoginReducer.token,
        userGroup: globalState.LoginReducer.userGroup,
        userEntryType: globalState.LoginReducer.userEntryType,
        currentStore: globalState.StoreReducer.currentStore,
    };
}

export default connect(mapStateToProps, { handleActiveLink, loaderStateTrue, loaderStateFalse, setUserEntryType })(withNamespaces()(Users));
